import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { getShortcutAppsList } from "../../store/shortcutApps/action";
import { isEmpty } from "lodash";
import { faviconFromUrl } from "../../helpers/functions/faviconFromUrl";

const WebAppsDropdown = () => {
  const dispatch = useDispatch();
  const [isWebAppDropdown, setIsWebAppDropdown] = useState(false);
  const toggleWebAppDropdown = () => {
    setIsWebAppDropdown(!isWebAppDropdown);
  };
  const { shortcutAppsList } = useSelector((state) => ({
    shortcutAppsList: state.ShortcutApps.shortcutAppsList?.shortcutquick_list,
  }));

  useEffect(() => {
    dispatch(getShortcutAppsList());
  }, []);
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isWebAppDropdown}
        toggle={toggleWebAppDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="bx bx-category-alt fs-22"></i>
        </DropdownToggle>
        <DropdownMenu className=" dropdown-menu-lg p-0 ">
          <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
            <Row className="align-items-center">
              {!isEmpty(shortcutAppsList) ? (
                <>
                  <Col>
                    <h6 className="m-0 fw-semibold fs-15">Shortcuts </h6>
                  </Col>
                  <div className="col-auto">
                    {/*<Link to="#" className="btn btn-sm btn-soft-info">*/}
                    {/*  {" "}*/}
                    {/*  View All Apps*/}
                    {/*  <i className="ri-arrow-right-s-line align-middle"></i>*/}
                    {/*</Link>*/}
                  </div>
                </>
              ) : (
                <span>You have no quick shortcuts.</span>
              )}
            </Row>
          </div>

          <div className="p-2">
            <div className="row g-0">
              {shortcutAppsList?.map((item, index) => (
                <Col key={index}>
                  <a
                    href={item?.LinkUrl || "/#"}
                    className="dropdown-icon-item"
                    // open new tab
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item?.ImageUrl ? (
                      <img src={item?.ImageUrl} alt={item?.Title} />
                    ) : faviconFromUrl(item?.LinkUrl) ? (
                      // Task 24845 - fall back to the site favicon so a shortcut
                      // with a link but no uploaded image still shows a real
                      // icon instead of the generic chain.
                      <img
                        src={faviconFromUrl(item?.LinkUrl)}
                        alt={item?.Title}
                      />
                    ) : (
                      <i className="fa-solid fa-link"></i>
                    )}
                    <span>{item?.Title}</span>
                  </a>
                </Col>
              ))}
            </div>

            {/*<div className="row g-0">*/}
            {/*  <Col>*/}
            {/*    <Link className="dropdown-icon-item" to="#">*/}
            {/*      <img src={dropbox} alt="dropbox" />*/}
            {/*      <span>Dropbox</span>*/}
            {/*    </Link>*/}
            {/*  </Col>*/}
            {/*  <Col>*/}
            {/*    <Link className="dropdown-icon-item" to="#">*/}
            {/*      <img src={mail_chimp} alt="mail_chimp" />*/}
            {/*      <span>Mail Chimp</span>*/}
            {/*    </Link>*/}
            {/*  </Col>*/}
            {/*  <Col>*/}
            {/*    <Link className="dropdown-icon-item" to="#">*/}
            {/*      <img src={slack} alt="slack" />*/}
            {/*      <span>Slack</span>*/}
            {/*    </Link>*/}
            {/*  </Col>*/}
            {/*</div>*/}
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default WebAppsDropdown;
